import { SubmissionRequest } from "../models/models";
import { NavigationContext } from "../core/services/wizardNavigationService/navigationcontext.model";

export interface IClientStateContext {
    id: string;
    userId: string;
    contextVersion: string;
    isComplete: boolean;
    createdAt: Date;
    submissionRequest: SubmissionRequest;
    navigationContext: NavigationContext;
}

export class ClientStateContext {
    id: string;
    userId: string;
    contextVersion: string;
    isComplete: boolean;
    createdAt: Date;
    submissionRequest: SubmissionRequest;
    navigationContext: NavigationContext;
}